// src/features/categories/categorySlice.ts
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCategories, Category } from "../../services/caregory";

interface CategoriesState {
  categories: Category[];
  loading: boolean;
  hasFetched: boolean;
  error: string | null;
}

const initialState: CategoriesState = {
  categories: [],
  loading: false,
  hasFetched: false,
  error: null,
};

// Async thunk to fetch all categories
export const fetchCategoriesThunk = createAsyncThunk(
  "categories/fetchCategories",
  async () => {
    const result = await getCategories({ page: 1, pageSize: 1000, sortOrder: "desc" });
    return result.data;
  }
);

const categorySlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    forceRefreshCategories(state) {
      state.hasFetched = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoriesThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategoriesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
        state.hasFetched = true;
      })
      .addCase(fetchCategoriesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch categories";
      });
  },
});

export const { forceRefreshCategories } = categorySlice.actions;
export default categorySlice.reducer;
